import React from 'react';
import {
    Box,
    Typography,
    IconButton,
    Button,
    TextField
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { IEditorMessages } from '../../../../types';
import { styles } from './ProgressTracker.styles';

interface TitleEditingProps {
    isEditing: boolean;
    title: string;
    onTitleChange: (value: string) => void;
    onSave: () => void;
    onCancel: () => void;
    onEdit: () => void;
    messages: IEditorMessages;
    readOnly: boolean;
}

export const TitleEditing = React.memo(({
    isEditing,
    title,
    onTitleChange,
    onSave,
    onCancel,
    onEdit,
    messages,
    readOnly
}: TitleEditingProps) => {
    const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onTitleChange(e.target.value);
    };

    const handleSave = () => {
        onSave();
    };

    const handleCancel = () => {
        onCancel();
    };

    const handleEdit = () => {
        onEdit();
    };

    if (isEditing) {
        return (
            <Box sx={styles.statusContainer}>
                <TextField
                    size="small"
                    value={title}
                    onChange={handleTitleChange}
                    variant="outlined"
                    sx={styles.titleTextField}
                />
                <Button
                    size="small"
                    onClick={handleSave}
                    variant="contained"
                    color="primary"
                >
                    {messages.save}
                </Button>
                <Button
                    size="small"
                    onClick={handleCancel}
                    variant="outlined"
                    color="error"
                >
                    {messages.cancel}
                </Button>
            </Box>
        );
    }

    return (
        <>
            <Typography variant="h4" component="h3">
                {title}
            </Typography>
            {!readOnly && <IconButton size="small" onClick={handleEdit} sx={styles.editIcon}>
                <EditIcon />
            </IconButton>}
        </>
    );
});

TitleEditing.displayName = 'TitleEditing'; 